module.exports = {
  props: {
    show: {
      type: Boolean,
      required: true,
      twoWay: true,
    },
    infoText: String,
  },

  data: function () {
    return {
      modalWidth: 600,
      title: "提示信息",
    }
  },

  components: {
    'modal': require('./modal.vue'),
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/info-modal.vue
// module id = 139
// module chunks = 0